<template>
  <div>
    <v-row
      class="my-5"
      v-if="data && data.inputs && data.inputs.length > 0 && data.inputs[0].srt_stats"
    >
      <videon-state-tile
        style="width: 140px;"
        v-for="(value, key) in data.inputs[0].srt_stats" 
        v-bind:key="key" 
        :heading="nameLabel(key)"
      >
        {{ value }}
      </videon-state-tile>
      
      <videon-state-tile
        style="width: 140px;"
        heading="Last Update"
      >
         {{ lastDataAt | moment("YYYY/MM/DD hh:mm:ss a") }}
      </videon-state-tile>
      
    </v-row>
    <v-progress-linear
      v-else
      class="mt-10"
      color="primary"
      indeterminate
      buffer-value="0"
    ></v-progress-linear>
  </div>
</template>

<script>
  import moment from 'moment'
  
  export default {
    name: 'SRTStats',
    
    props: ['device_guid'],
    
    data() {
      return {
        error: false,
        errorText: '',
        
        subscription: false,
        
        data: false,
        lastDataAt: false,
        
        destroyed: false,
      }
    },
    
    computed: {
      rtMetricsTopic() {
        return 'dt/videon_cloud/device/' + this.device_guid + '/rt_metrics/srt_stats'
      },
      pubsub() {
        return this.$Amplify.PubSub
      },
      device() {
        return this.$devices.getDevice(this.device_guid)
      },
    },
    
    mounted() {
      setTimeout(() => {
        this.setupMetrics()
      }, this.$helpers.getRefreshInterval(250, 1000))
    },
    
    beforeDestroy() {
      this.destroyed = true
      
      clearTimeout(this.requestTimer)
      
      if (this.subscription) {
        console.log('SRTStats ' + this.device_guid + ' unsubscribe ' + this.rtMetricsTopic)
        this.subscription.unsubscribe()
      }
    },
    
    methods: {
      nameLabel(stateName) {
        if (typeof stateName === 'string') {
          return stateName.replace(/_/g, ' ')
        } else if (typeof stateName === 'number') {
          return stateName
        } else if (typeof stateName === 'object') {
          return 'Object'
        }
        return typeof stateName
      },
      
      setupMetrics() {
        // handle all the error logic here...
        if (!this.device.isOnline()) {
          this.error = true
          this.errorText = 'Feature unavailable when the device is offline.'
          
          setTimeout(() => {
            this.setupMetrics()
          }, 5000)
        } else {
          this.subscribeToTopic()
        }
      },
      
      subscribeToTopic() {
        if (!this.device_guid) {
          return
        }
        
        if (!this.subscription) {
          console.log('SRTStats ' + this.device_guid + ' subscribeToTopic ' + this.rtMetricsTopic)
          
          this.subscription = this.pubsub.subscribe(this.rtMetricsTopic).subscribe({
            next: (data) => {
              if (data.value) {
                this.data = data.value
                
                this.lastDataAt = moment()
                
                // reset error
                this.error = false
                this.errorText = ''
              }
            },
            error: (error) => {
              console.log('SRTStats ' + this.device_guid + ' subscribeToTopic Error:', error)
              this.error = true
              this.errorText = this.$helpers.parseError(error)
            },
            complete: () => {
              console.log('SRTStats ' + this.device_guid + ' subscribeToTopic complete')
            }
          })
        }
      },
    }
  }
</script>